import React from 'react';
import './link-button.css';

export function ActionButton({ text, onClick, className, disabled }) {

    return (
        <div>
            <button
                onClick={onClick}
                className={`action-button pointer b2-m ${className || ''}`}
                disabled={disabled}>
                {text}
            </button>
        </div>
    );
}